import { render, staticRenderFns } from "./ItemRequest.vue?vue&type=template&id=63fc5e28&scoped=true&"
import script from "./ItemRequest.vue?vue&type=script&lang=js&"
export * from "./ItemRequest.vue?vue&type=script&lang=js&"
import style0 from "./ItemRequest.vue?vue&type=style&index=0&id=63fc5e28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc5e28",
  null
  
)

export default component.exports